"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUGGESTIONS_COUNT = exports.SECTION_LABEL_WIDTH = exports.SECTION_LABEL_HEIGHT = exports.SEARCH_PREVIEW_SKELETON_SUGGESTION = exports.SEARCH_PREVIEW_SKELETON_CATEGORIES = exports.SEARCH_PREVIEW_SKELETON_BRANDS = exports.SEARCH_PREVIEW_SKELETON = exports.SEARCH_PREVIEW_PRODUCT_SKELETON = exports.PRODUCTS_COUNT = exports.CATEGORIES_COUNT = exports.BRANDS_COUNT = void 0;
const SEARCH_PREVIEW_SKELETON = exports.SEARCH_PREVIEW_SKELETON = 'search-preview-skeleton';
const SEARCH_PREVIEW_PRODUCT_SKELETON = exports.SEARCH_PREVIEW_PRODUCT_SKELETON = 'search-preview-product-skeleton';
const SEARCH_PREVIEW_SKELETON_SUGGESTION = exports.SEARCH_PREVIEW_SKELETON_SUGGESTION = 'search-preview-skeleton-suggestion';
const SEARCH_PREVIEW_SKELETON_BRANDS = exports.SEARCH_PREVIEW_SKELETON_BRANDS = 'search-preview-skeleton-brands';
const SEARCH_PREVIEW_SKELETON_CATEGORIES = exports.SEARCH_PREVIEW_SKELETON_CATEGORIES = 'search-preview-skeleton-categories';
const PRODUCTS_COUNT = exports.PRODUCTS_COUNT = 3;
const SUGGESTIONS_COUNT = exports.SUGGESTIONS_COUNT = 3;
const BRANDS_COUNT = exports.BRANDS_COUNT = 4;
const CATEGORIES_COUNT = exports.CATEGORIES_COUNT = 2;
const SECTION_LABEL_HEIGHT = exports.SECTION_LABEL_HEIGHT = 25;
const SECTION_LABEL_WIDTH = exports.SECTION_LABEL_WIDTH = 70;
